var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.346 3.566L4 9.917V20a1 1 0 001 1h14a1 1 0 001-1V9.917l-7.346-6.351a1 1 0 00-1.308 0z",
    fill: "#6244FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6v6.192a1 1 0 00.528.882l5 2.674a1 1 0 00.944 0l5-2.674a1 1 0 00.528-.882V6a1 1 0 00-1-1H7a1 1 0 00-1 1z",
    fill: "#F4F2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.818 12.178h4.5v-4.5l-4.5 4.5z",
    fill: "#EB6963"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.318 12.178h-4.5v-4.5l4.5 4.5z",
    fill: "#4C49E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V10L5 21h14a1 1 0 001-1z",
    fill: "#9580FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20V10l15 11H5a1 1 0 01-1-1z",
    fill: "#C2B6FF"
  })));
}

export default SvgApplication;